var React = require('react');

function PLAYHEADM (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-555.031 -881.451)","stroke":"#000","strokeMiterlimit":"10"},[React.createElement("circle",{"cx":"22.172","cy":"22.172","r":"22.172","transform":"translate(555.531 881.951)","fill":"#f40","key":0}),React.createElement("path",{"d":"M572.098 893.227v21.793c0 .632 1 .949 1.581.5l14.227-10.9a.6.6 0 000-1l-14.227-10.9c-.581-.442-1.581-.126-1.581.507z","fill":"#fff","key":1})]));
}

PLAYHEADM.defaultProps = {"width":"45.344","height":"45.343"};

module.exports = PLAYHEADM;

PLAYHEADM.default = PLAYHEADM;
